/* eslint-disable max-len */
/* eslint-disable react/jsx-no-target-blank */
import React from "react";

import "./contact.m.css";

export function ContactUsPage() {
  return (
    <section>
      <main styleName="hero-section">
        <div>
          <div styleName="hero-section-content">
            <h1 styleName="title">Get in touch</h1>
            <p styleName="border-bottom"></p>
            <h3 styleName="description">
              Newslaundry is built on the faith of an engaged, active, alert and
              concerned reader base. We welcome your suggestions, criticism,
              ideas.
            </h3>
          </div>
          <div styleName="hero-section-img">
            <img
              src="https://images.assettype.com/newslaundry/2020-11/710e42aa-0704-4d0d-8059-bea12f58460d/22_Notification_page__1_.png"
              alt="Valentines Mystery box"
            />
          </div>
        </div>
      </main>
      <div styleName="sub-section">
        <div styleName="enquiry-block">
          <p styleName="enquiry-text">
            For submissions and editorial enquiries:
          </p>
          <a
            target="_blank"
            styleName="enquiry-link"
            href="mailto:submissions@newslaundry.com"
          >
            Get in touch
          </a>
        </div>
        <div styleName="enquiry-block">
          <p styleName="enquiry-text">For internships and job enquiries:</p>
          <a
            target="_blank"
            styleName="enquiry-link"
            href="mailto:careers@newslaundry.com"
          >
            Get in touch
          </a>
        </div>
        <div styleName="enquiry-block">
          <p styleName="enquiry-text">For podcast letters and feedback:</p>
          <a
            target="_blank"
            styleName="enquiry-link"
            href="mailto:podcasts@newslaundry.com"
          >
            Get in touch
          </a>
        </div>
        <div styleName="enquiry-block">
          <p styleName="enquiry-text">For subscription queries and support:</p>
          <a
            target="_blank"
            styleName="enquiry-link"
            href="mailto:subscription@newslaundry.com"
          >
            Get in touch
          </a>
        </div>
        <div styleName="enquiry-block">
          <p styleName="enquiry-text">For event partnerships:</p>
          <a
            target="_blank"
            styleName="enquiry-link"
            href="mailto:suhana@newslaundry.com"
          >
            Get in touch
          </a>
        </div>
        <div styleName="enquiry-block">
          <p styleName="enquiry-text">For The Media Rumble:</p>
          <a
            target="_blank"
            styleName="enquiry-link"
            href="mailto:info@themediarumble.com"
          >
            Get in touch
          </a>
        </div>
        <div styleName="enquiry-block">
          <p styleName="enquiry-text">For merchandise related queries:</p>
          <a
            target="_blank"
            styleName="enquiry-link"
            href="mailto:store@newslaundry.com"
          >
            Get in touch
          </a>
        </div>
        <div styleName="enquiry-block">
          <p styleName="enquiry-text">Grievance Redressal form:</p>
          <a
            target="_blank"
            styleName="enquiry-link"
            href="https://digipub.webnyay.in/"
          >
            File a complaint
          </a>
        </div>
      </div>
    </section>
  );
}
